




















import {
    Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import DatePicker from '@/components/global/input/DatePicker.vue';
import TimePicker from '@/components/global/input/TimePicker.vue';

@Component({
    components: {
        DatePicker,
        TimePicker,
    },
})
export default class DateTimePicker extends Vue {
    @Prop({ default: '00:00' }) public timeDefault!: string;
    @Prop() public date!: string;
    @Prop() public time!: string;
    @Prop({ default: 'Label' }) public dateLabel!: string;
    @Prop({ default: null }) public dateMin!: string;


    public onDateInput(event: any) {
        this.$emit('update:date', event);
    }

    public onTimeInput(event: any) {
        this.$emit('update:time', event);
    }

    @Watch('date')
    onDateChanged(val: any, oldVal: any) {
        this.$emit('update:date', val);
    }

    @Watch('date')
    onTimeChanged(val: any, oldVal: any) {
        this.$emit('update:date', val);
    }
}
